<template>
  <main class="public-page-shell relative min-h-full overflow-hidden bg-neutral-10 text-black">
    <div aria-hidden="true" class="pointer-events-none absolute inset-0">
      <div
        class="absolute inset-0 opacity-[0.07]"
        style="
          background-image:
            linear-gradient(to right, rgba(255,255,255,0.15) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.15) 1px, transparent 1px);
          background-size: 24px 24px;
        "
      ></div>

      <div
        class="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,0,0,0)_0%,rgba(0,0,0,0.42)_60%,rgba(0,0,0,0.9)_100%)]"
      ></div>

      <div
        class="absolute -top-32 -left-32 h-[38rem] w-[38rem] rounded-full opacity-30 blur-3xl"
        :style="{
          background:
            'radial-gradient(circle at 30% 30%, var(--color-scio-yellow-p2) 0%, transparent 60%)',
        }"
      ></div>

      <div
        class="absolute bottom-[-18rem] right-[-16rem] h-[36rem] w-[36rem] rounded-full opacity-20 blur-3xl"
        :style="{
          background:
            'radial-gradient(circle at 40% 40%, var(--color-scio-yellow-p4) 0%, transparent 62%)',
        }"
      ></div>
    </div>

    <div class="relative z-10 flex min-h-full flex-col">
      <slot />
    </div>
  </main>
</template>

<script>
export default {
  name: "PublicPageShell",
};
</script>

<style>
/* Public pages use a flatter editorial surface. Keep circular status dots and logo treatments intact. */
.public-page-shell [class~="rounded-sm"],
.public-page-shell [class~="rounded-md"],
.public-page-shell [class~="rounded-lg"],
.public-page-shell [class~="rounded-xl"],
.public-page-shell [class~="rounded-2xl"],
.public-page-shell [class~="rounded-3xl"] {
  border-radius: 0 !important;
}

.public-page-shell [class~="backdrop-blur-sm"],
.public-page-shell [class~="backdrop-blur-md"] {
  backdrop-filter: none !important;
}

.public-page-shell [class~="bg-white/5"] {
  background-color: transparent !important;
}
</style>
